module.exports = __webpack_public_path__ + "static/img/10.9f7241a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10.png
// module id = 3AJl
// module chunks = 0